<template>
  <dx-tree-list
    id="mped-report-results-tree-list"
    class="flex-grow-1"
    height="50px"
    width="100%"
    ref="treeListRef"
    column-resizing-mode="widget"
    filter-mode="fullBranch"
    parentIdExpr="kod_parent"
    :data-source="dataSource"
    :columns="columns"
    :header-filter="{ visible: true }"
    :filter-panel="{ visible: true }"
    :filter-row="{ visible: true }"
    :allow-column-resizing="true"
    :hover-state-enabled="true"
    :show-column-lines="true"
    :show-row-lines="true"
    :show-borders="true"
    :column-min-width="70"
    :column-chooser="{ enabled: true, mode: 'select' }"
    @toolbar-preparing="onToolbarPreparing($event)"
    @content-ready="onContentReady($event)"
  >
    <dx-load-panel :enabled="true"/>
    <dx-scrolling mode="virtual"/>
    <dx-sorting mode="single"/>
    <dx-selection mode="single" />
    <template #filterFirstTemplate>
      <span>Год:</span>
      <dx-select-box
        v-model="filter.year"
        :data-source="yearDataSource"
        width="100%"
        :showClearButton="false"
        @valueChanged="reloadData()"
      />
    </template>
    <template #filterSecondTemplate>
      <span>Месяц с:</span>
      <dx-select-box
        v-model="filter.monthIdFrom"
        :data-source="monthsList"
        width="100%"
        value-expr="id"
        display-expr="name"
        :showClearButton="false"
        @valueChanged="reloadData()">
      </dx-select-box>
    </template>
    <template #filterThirdTemplate>
      <span>Месяц по:</span>
      <dx-select-box
        v-model="filter.monthIdTo"
        :data-source="monthsList"
        width="100%"
        value-expr="id"
        display-expr="name"
        :showClearButton="false"
        @valueChanged="reloadData()"
      />
    </template>
    <template #filterFourthTemplate>
      <ai-drop-down-tab
        ref="sprDepartmentComboRef"
        :columns="[{ caption: 'Наименование', dataField: 'name' }]"
        :get-data-source="getDsSprDepartmentsCombo"
        drop-down-width="400"
        key-expr="id"
        parent-id-expr="parent_id"
        valueExpr="name"
        placeholder="Подразделение:"
        selectionMode="single"
        :default-value="filter.departmentId"
        :displayPlaceholder="false"
        :chooseAll="false"
        :showClearButton="false"
        :showColumnHeaders="false"
        :show-filter-row="true"
        :validate-required="true"
        dropDownHeight="100%"
        @value-changed="changedFilter($event, 'departmentId')"
      ></ai-drop-down-tab>
    </template>
    <template #filterFifthTemplate>
      <span>Показывать расшифровку:</span>
      <dx-select-box
        v-model="filter.plFactId"
        :data-source="plFactIdSelectBox"
        width="100%"
        value-expr="id"
        display-expr="name"
        :showClearButton="false"
        @valueChanged="changeVisibleColumns()"
      />
    </template>
  </dx-tree-list>
  <footer-grid
    class="pr-1"
    :totalCount="totalCount"
    :showSelectedCounter="false"
  ></footer-grid>
</template>

<script>
export default {
  name: 'mped-report-results-nd-view',
};
</script>

<script setup>
import { computed, onBeforeMount, ref, watch } from 'vue';
import {
  DxLoadPanel,
  DxScrolling,
  DxSelection,
  DxSorting,
  DxTreeList,
} from 'devextreme-vue/tree-list';
import { DxSelectBox } from 'devextreme-vue';

import {
  monthsList,
  plFactIdSelectBox,
  getResultNd,
  getResultNdColumns,
  getYearsList,
  getSprDepartmentsCombo,
} from '@/views/mped/services/mped-estimate-service';
import { expandTree, getAiDataSource } from '@/components/utils/ai-data-source-generator';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import AiDropDownTab from '@/components/ai-drop-down-tab/ai-drop-down-tab.vue';
import { useRouter } from 'vue-router';
import { getUserData, setUserData } from '@/views/mped/services/mped-service';
import FooterGrid from '@/components/grid-card-component/footer-grid.vue';

const
  totalCount = ref(0),
  treeListRef = ref(),
  isExpand = ref(true),
  yearDataSource = ref(),
  filter = ref({
    year: new Date().getFullYear(),
    monthIdFrom: 1,
    monthIdTo: 12,
    departmentId: null,
    plFactId: '2',

  });

let columns = [];
let isAfterLoad = false;
let allIds = [];

const dataSource = getAiDataSource(
  {
    validationFn: () =>  filter.value.year && filter.value.monthIdFrom && filter.value.monthIdTo
      && filter.value.plFactId && filter.value.departmentId,
    dataFn: getResultNd,
    paramsFn: () => Object.assign({}, {
      year: filter.value.year,
      monthIdFrom: filter.value.monthIdFrom,
      monthId: filter.value.monthIdTo,
      departmentId: filter.value.departmentId,
      plFactId: filter.value.plFactId,
      formaId: 4,
    }),
    key: 'kod_spr_smet',
    onLoadedFn: (result) => {
      isAfterLoad = true;
      totalCount.value = result.totalCount;
      allIds = result.data.map(x => x.kod_spr_smet);
    },
  },
);

const router = useRouter();

const userDataKey = computed({
  get: () => router.currentRoute.value.name
});

watch(filter.value, () => {
  saveUserData();
});

const saveUserData = () => {
  if (userDataKey.value) {
    setUserData(userDataKey.value, filter.value);
  }
};

onBeforeMount(async () => {
  yearDataSource.value = getYearsList((new Date()).getFullYear(), 4, 4);
  if (userDataKey.value && getUserData(userDataKey.value))
    filter.value = getUserData(userDataKey.value);
  await changeVisibleColumns();
});

const reloadData = () => {
  dataSource.reload();
}

const reloadDataAndClearSort = () => {
  reloadData();
  treeListRef.value.instance.clearSorting()
}

const getInstance = () => {
  return treeListRef.value.instance;
};

const onContentReady = (e) => {
  if (isAfterLoad) {
    expandTree({
      ids: allIds,
      dxInstance: getInstance(),
    });
  }
  isAfterLoad = false;
};

const onToolbarPreparing = (e) => {
  e.toolbarOptions.elementAttr = {
    class: 'ai-toolbar-row-with-label',
  };
  getAiToolbar(e, {
    customs: [
      {
        location: 'before',
        template: 'filterFirstTemplate',
      }, {
        location: 'before',
        template: 'filterSecondTemplate',
      }, {
        location: 'before',
        template: 'filterThirdTemplate',
      }, {
        location: 'before',
        template: 'filterFourthTemplate',
      }, {
        location: 'before',
        template: 'filterFifthTemplate',
      }],
    expand: {
      event: (e) => {
        isExpand.value = !isExpand.value;
        expandTree({
          ids: allIds,
          dxInstance: getInstance(),
          expand: isExpand.value
        });
      },
    },
    refresh: {
      event: (e) => {
        reloadDataAndClearSort();
      },
    },
  });
};

const changedFilter = (e, filed) => {
  if (e.value) {
    filter.value[filed] = e.value;
  } else {
    filter.value[filed] = e;
  }
  reloadData();
};

const getColumns = async () => {
  columns = await getResultNdColumns(filter.value.plFactId, filter.value.year + '.' + filter.value.monthIdTo);
}

const changeVisibleColumns = async () => {
  await getColumns();
  treeListRef.value.instance.option('columns', columns);
  await reloadData();
};

const getDsSprDepartmentsCombo = async () => {
  return await getSprDepartmentsCombo({ formaId: 4, year: filter.value.year });
};

</script>
